<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__bank_accounts_iii')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__funds_outside_banks_table')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.funds_outside === row.value}" v-for="(row, index) in tableFundsOutside" :key="index">
                <td>
                  <radio name="model.funds_outside"
                         :value="row.value"
                         v-model="EvaluationForm.model.funds_outside"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="4" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.funds_outside}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_funds" :comments="EvaluationForm.model.comments_funds"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__financial_capacity')}}</h5>
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__financial_capacity_i')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__financial_capacity_table')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.financial_capacity === row.value}" v-for="(row, index) in tableFinancialCapacity" :key="index">
                <td>
                  <radio name="model.financial_capacity"
                         :value="row.value"
                         v-model="EvaluationForm.model.financial_capacity"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="5" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.financial_capacity}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_financial_capacity" :comments="EvaluationForm.model.comments_financial_capacity"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__financial_capacity_ii')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__financial_capacity_table_i')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.financial_capacity_i === row.value}" v-for="(row, index) in tableFinancialCapacityI" :key="index">
                <td>
                  <radio name="model.financial_capacity_i"
                         :value="row.value"
                         v-model="EvaluationForm.model.financial_capacity_i"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="5" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.financial_capacity_i}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_funding_sources" :comments="EvaluationForm.model.comments_funding_sources"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__financial_capacity_iii')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__financial_capacity_table_iii')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.financial_capacity_iii === row.value}" v-for="(row, index) in tableFinancialCapacityIii" :key="index">
                <td>
                  <radio name="model.financial_capacity_iii"
                         :value="row.value"
                         v-model="EvaluationForm.model.financial_capacity_iii"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="5" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.financial_capacity_iii}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_grant_funding" :comments="EvaluationForm.model.comments_grant_funding"></comment-box>
            </div>
          </div>
        </div>

      </div>

      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      CommentBox
    },
    data() {
      return {
        EvaluationForm,
        tableFundsOutside: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__bank_accounts_iii_0')},
          {'value': 2, 'text': this.$i18n.t('medium_grant_ev.diligence__bank_accounts_iii_2')},
          {'value': 8, 'text': this.$i18n.t('medium_grant_ev.diligence__bank_accounts_iii_8')},
        ],
        tableFinancialCapacity: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__financial_capacity_table_0')},
          {'value': 1, 'text': this.$i18n.t('medium_grant_ev.diligence__financial_capacity_table_1')},
          {'value': 3, 'text': this.$i18n.t('medium_grant_ev.diligence__financial_capacity_table_3')},
          {'value': 6, 'text': this.$i18n.t('medium_grant_ev.diligence__financial_capacity_table_6')},
          {'value': 8, 'text': this.$i18n.t('medium_grant_ev.diligence__financial_capacity_table_8')},
        ],
        tableFinancialCapacityI: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__financial_capacity_table_i_0')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__financial_capacity_table_i_4')}
        ],
        tableFinancialCapacityIii: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__financial_capacity_table_iii_0')},
          {'value': 1, 'text': this.$i18n.t('medium_grant_ev.diligence__financial_capacity_table_iii_1')},
          {'value': 2, 'text': this.$i18n.t('medium_grant_ev.diligence__financial_capacity_table_iii_2')},
          {'value': 3, 'text': this.$i18n.t('medium_grant_ev.diligence__financial_capacity_table_iii_3')},
        ]
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
    }
  }
</script>